import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import AppointmentTabs from '../Components/AppointmentTabs';
import * as providerUpcomingAppointmentList from '../../../redux/healthboard/requests/virtual-appointments-upcomming-req';
import * as providerHistoryAppointmentList from '../../../redux/healthboard/requests/virtual-appointments-history-req';
import * as providerUpcomingFilter from '../../../redux/healthboard/appointment-upcoming-filters';
import {
  selectProviderUpcomingCount,
  selectProviderUpcomingAppointmentList,
  selectProviderUpcomingAppointmentsPending,
  selectProviderHistoryCount,
  selectProviderHistoryAppointmentList,
  selectProviderHistoryAppointmentsPending,
  selectProviderUpcomingFilterToday,
  selectProviderUpcomingFilterByTypeVisit,
  selectProviderHistoryPaginationPending,
  selectProviderUpcomingPaginationPending,
} from '../../../redux/healthboard/selectors';

const mapStateToProps = state => ({
  upcomingList: selectProviderUpcomingAppointmentList(state),
  upcomingCount: selectProviderUpcomingCount(state),
  upcomingLoading: selectProviderUpcomingAppointmentsPending(state),
  upcommingPaginationLoading: selectProviderUpcomingPaginationPending(state),
  historyLoading: selectProviderHistoryAppointmentsPending(state),
  historyPaginationLoading: selectProviderHistoryPaginationPending(state),
  historyList: selectProviderHistoryAppointmentList(state),
  historyCount: selectProviderHistoryCount(state),
  isFilterToday: selectProviderUpcomingFilterToday(state),
  isFilterByTypeVisit: selectProviderUpcomingFilterByTypeVisit(state),
});
const mapDispatchToProps = {
  fetchUpcomingList: providerUpcomingAppointmentList.actions.send,
  loadMoreUpcomingList: providerUpcomingAppointmentList.actions.loadMore,
  fetchHistoryList: providerHistoryAppointmentList.actions.send,
  loadMoreHistoryList: providerHistoryAppointmentList.actions.loadMore,
  setAppointmentFiltersOption: providerUpcomingFilter.actions.set,
};

const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({ userId, historyPaginationLoading, upcommingPaginationLoading }) => ({
      id: userId,
      providerContext: true,
      providerView: true,
      paginationSending: upcommingPaginationLoading || historyPaginationLoading,
    }),
  ),
);

const ProviderAppointmentList = enhance(AppointmentTabs);
export default ProviderAppointmentList;



// WEBPACK FOOTER //
// ./src/components/Healthboard/ProviderAppointmentList/index.jsx